// Phase 11 — Goals module hook.
import { useQuery } from '@tanstack/react-query';

interface GoalMilestone { id: string; goal_id: string; title: string; completed: number; }
interface GoalEntry { id: string; title: string; description: string; target_date: string | null; progress_pct: number; status: string; milestones: GoalMilestone[]; }

export function useGoals() {
  return useQuery<GoalEntry[]>({
    queryKey: ['goals', 'entries'],
    queryFn: async () => {
      const res = await fetch('/api/modules/goals/entries', { credentials: 'same-origin' });
      if (!res.ok) throw new Error('Failed to load goals');
      return res.json();
    },
    staleTime: 30_000,
  });
}
